import React from 'react'

export default function PageViews({ pageViews }: { pageViews: string | number }) {
    return <p className="m-0 font-semibold opacity-50">{pageViews} views</p>
}
